import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteReserVoucherOffer, EditReserVoucherOffer, ReserVoucherOffers, SaveReserVoucherOffer } from "../../Services/Service";

// ✅ Async Thunk
export const fetchVoucherOffers = createAsyncThunk(
    "voucherOffers/fetchVoucherOffers",
    async (propertyId) => {
        const response = await ReserVoucherOffers(propertyId);
        return response;
    }
);

export const saveVoucherOffer = createAsyncThunk(
    "voucherOffers/saveVoucherOffer",
    async (postData) => {
        const response = await SaveReserVoucherOffer(postData);
        return response;
    }
);

export const deleteVoucherOffer = createAsyncThunk(
    "voucherOffers/deleteVoucherOffer",
    async (id) => {
        await DeleteReserVoucherOffer(id);
        return id;   // 👈 sirf id return karenge
    }
);

export const updateVoucherOffer = createAsyncThunk(
    "voucherOffers/updateVoucherOffer",
    async (postData) => {
        const response = await EditReserVoucherOffer(postData);
        return response; // updated object return karega
    }
);

const voucherOffersSlice = createSlice({
    name: "voucherOffers",
    initialState: {
        offersList: [],
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVoucherOffers.fulfilled, (state, action) => {
                state.offersList = action.payload;
            })
            .addCase(fetchVoucherOffers.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(deleteVoucherOffer.fulfilled, (state, action) => {
                // ✅ Local state se remove
                state.offersList = state.offersList.filter(
                    item => item.ID !== action.payload
                );
            })

            .addCase(updateVoucherOffer.fulfilled, (state, action) => {
                const updatedItem = action.payload;

                const index = state.offersList.findIndex(
                    item => item.ID === updatedItem.ID
                );

                if (index !== -1) {
                    state.offersList[index] = updatedItem;
                }
            })
    },
});

export default voucherOffersSlice.reducer;